import { Box } from '@material-ui/core';

import { ParticipantCard } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/Participants/components/ParticipantCard';
import { useParticipants } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/Participants/hooks/useParticipants';
import { IconHeader } from '@/components/shared/components/IconHeader';
import { Participant } from '@/config/types';

interface ParticipantsProps {
  agentId: string;
  merchantId: string;
}
const Participants = ({ agentId, merchantId }: ParticipantsProps) => {
  const participants: { agent?: Participant; channel?: Participant; merchant?: Participant } = useParticipants({
    agentId,
    merchantId,
  });

  return (
    <Box display={'flex'} flexDirection={'column'}>
      <IconHeader iconName={'group'} labelTid={'MERCHANT_CHANNEL_AGENT_POS'} color={'secondary'} />
      <Box mb={3} />
      {Object.values(participants).map(
        (participant, key) => participant && <ParticipantCard key={key} participant={participant} />,
      )}
    </Box>
  );
};

export { Participants };
